import { IDBService } from '../IDBService.js';
export class AckInfoStore extends IDBService {
    constructor() {
        super(...arguments);
        this.getAckInfo = async () => {
            const result = await this.run('info', (store) => store.get('ack'));
            if (result) {
                return result;
            }
            else {
                return {
                    globalAckTimestamp: null,
                    type: 'ack',
                };
            }
        };
        this.setGlobalAck = async (ack) => {
            await this.run('info', (store) => store.put({ type: 'ack', globalAckTimestamp: ack }), 'readwrite');
        };
    }
}
//# sourceMappingURL=AckInfoStore.js.map